export default "__VITE_ASSET__DWWF$_8L__"